import React, { useState } from 'react'
import Modal from 'react-modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faInstagramSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons'
import { Link } from 'react-router-dom'

import './Footer.css'
import './Modal.css'

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,.7)',
    zIndex: 9999
  },
  content : {
    border: 0,
    borderRadius: 0,
    padding: 0,
    top : '50%',
    left : '50%',
    right : 'auto',
    bottom : 'auto',
    transform : 'translate(-50%, -50%)'
  }
};

Modal.setAppElement('#root');

const carCertifiedButton = () => {
  localStorage.setItem('condition', 'Capella Certified')
  window.location.replace('/gallery/mobil')
}

const Footer = () => {
  const [modalGaransiOpen, setModalGaransiOpen] = useState(false)
  const [modalFaqOpen, setModalFaqOpen] = useState(false)

  return (
    <footer className="section-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-sm-6 col-6">
            <div className="footer-menu-wrapper">
              <div className="mb--1">
                <p className="text--size-14 title-border title-border--orange">LAYANAN KAMI</p>
              </div>
              <div className="footer-menu">
                <ul>
                  <li>
                    <Link onClick={() => carCertifiedButton()}>Beli Mobil Certified</Link>
                  </li>
                  <li>
                    <Link onClick={() => window.location.replace('/gallery/motor')}>Beli Motor Bekas</Link>
                  </li>
                  <li onClick={() => setModalGaransiOpen(true)}>Garansi</li>
                  <li onClick={() => setModalFaqOpen(true)}>FAQ</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-6">
            <div className="footer-menu-wrapper">
              <div className="mb--1">
                <p className="text--size-14 title-border title-border--orange">SOCIAL MEDIA</p>
              </div>
              <div className="footer-menu">
                <div className="footer-social-media-item">
                  <span className="mr--1">
                    <a href="https://www.facebook.com/profile.php?id=100068288331414" target="_blank"><FontAwesomeIcon icon={faFacebookSquare} /></a>
                  </span>
                  <span className="mr--1">
                    <a href="https://www.instagram.com/oto.cmd/" target="_blank"><FontAwesomeIcon icon={faInstagramSquare} /></a>
                  </span>
                  <span>
                    <a href="https://www.youtube.com/channel/UCSOmvtPH4AWFNMwnLTYgBsQ" target="_blank"><FontAwesomeIcon icon={faYoutubeSquare} /></a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="footer-menu-wrapper">
              <div className="mb--1">
                <p className="text--size-14 title-border title-border--orange">TENTANG KAMI</p>
              </div>
              <div className="footer-menu">
                <p>
                  Oto.cmd adalah perusahaan yang bergerak di bidang penjualan mobil dan motor, sejak tahun 1998 kami hadir untuk melayani konsumen dengan sepenuh hati. Kini kami hadir di media digital untuk membantu para konsumen agar mendapatkan kendaran impian dengan mudah. Oto.cmd hanya menampilkan produk dari mereka sendiri untuk memastikan kendaraan yang sampai di tangan konsumen dengan kondisi yang baik. Saat ini Oto.cmd melayani di beberapa kota yaitu, di kota Banda Aceh, Lhokseumawe, Bireuen, Meulaboh, Medan, Pekanbaru, Duri, Pangkalan Kerinci, Perawang, Dumai, dan Padang dengan berbagai merk kendaraan. Kami memberikan pengalaman membeli Kendaraan dengan proses mudah, aman dan nyaman. Dapatkan penawaran terbaik untuk Kendaraan impian Anda.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={modalFaqOpen}
        onRequestClose={() => setModalFaqOpen(false)}
        style={customStyles}
      >
        <div className="modal-wrapper">
          <div className="modal-close-icon">
            <span onClick={() => setModalFaqOpen(false)}><FontAwesomeIcon icon={faTimes} /></span>
          </div>
          <div className="modal-body">
            <div className="mb--1">
              <h1 className="title-big">
                FAQ
              </h1>
            </div>
            <div className="mb--1">
              <p><strong>Apa keunggulan oto.cmd?</strong></p>
              <p>
                Oto.cmd menyediakan kendaraan bekas berkualitas dengan merek serta tipe yang beragam. Kendaraan yang disediakan 100% siap pakai. Khusus mobil capella certified kendaraan sudah melalui proses pengecekan oleh mekanik resmi dan mendapatkan garansi 100 hari dengan jaminan dokumen lengkap, mobil bebas banjir, bebas kecelakaan, lulus 153 poin inspeksi dan odometer yang original.
              </p>
            </div>
            <div className="mb--1">
              <p><strong>Bagaimana jika kendaraan yang diinginkan tidak tersedia?</strong></p>
              <p>
                Anda dapat menghubungi Showroom terdekat dari lokasi anda terkait unit kendaraan yang anda inginkan dan akan di informasikan apabila unit yang diinginkan telah tersedia.
              </p>
            </div>
            <div className="mb--1">
              <p><strong>Apakah mobil yang dibeli sudah termasuk asuransi?</strong></p>
              <p>
                Tidak, jika Anda membeli secara tunai. Asuransi hanya tersedia jika Anda membeli mobil secara kredit.
              </p>
            </div>
            <div className="mb--1">
              <p><strong>Jenis asuransi apa yang tersedia di oto.cmd?</strong></p>
              <p>
                Jenis Asuransi yang kami sediakan adalah asuransi All Risk dan TLO (Total Loss Only).
              </p>
            </div>
            <div className="mb--1">
              <p><strong>Apa saja dokumen yang perlu dipersiapkan?</strong></p>
              <ul>
                <li><p>Cash: Untuk pembelian unit secara Cash Anda hanya perlu mempersiapkan Fotocopy KTP dan KK saja.</p></li>
                <li><p>Kredit: Untuk pembelian unit secara Kredit Anda harus mempersiapkan Fotocopy KTP & KK, Data Penghasilan, dan Rekening Listrik.</p></li>
              </ul>
            </div>
            <div className="mb--1">
              <p><strong>Bagaimana cara membeli kendaraan di oto.cmd?</strong></p>
              <p>Kamu dapat langsung menghubungi admin ataupun mengisi data diri informasi lebih lanjut.</p>
            </div>
            <div className="mb--1">
              <p><strong>Apakah di oto.cmd bisa tukar tambah?</strong></p>
              <p>Tidak, Saat ini kami tidak menerima sistem tukar tambah kendaraan roda empat maupun roda dua.</p>
            </div>
            <div className="mb--1">
              <p><strong>Apakah di oto.cmd dapat menerima Kendaraan bekas untuk dijual?</strong></p>
              <p>Saat ini Kami hanya menjual unit milik kami sendiri saja dan tidak ada perantara pihak ke tiga.</p>
            </div>
            <div className="mb--1">
              <p><strong>Dimana sajakah lokasi showroom oto.cmd?</strong></p>
              <p>Lokasi showroom kami dapat anda ketahui melalui di halaman utama oto.cmd</p>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={modalGaransiOpen}
        onRequestClose={() => setModalGaransiOpen(false)}
        style={customStyles}
      >
        <div className="modal-wrapper">
          <div className="modal-close-icon">
            <span onClick={() => setModalGaransiOpen(false)}><FontAwesomeIcon icon={faTimes} /></span>
          </div>
          <div className="modal-body">
            <div className="mb--1">
              <h1 className="title-big">
                Garansi Capella Certified
              </h1>
            </div>
            <div className="mb--1">
              <p><strong>Syarat dan Ketentuan Garansi Capella Certified</strong></p>
            </div>
            <div>
              <ul>
                <li><p>Garansi hanya berlaku untuk kerusakan mesin.</p></li>
                <li><p>Masa berlaku garansi adalah 100 hari kalender setelah serah terima kendaraan dan hanya dapat dilakukan sebanyak 1 kali.</p></li>
                <li><p>Proses klaim garansi wajib membawa sertifikat dan hasil inspeksi kendaraan.</p></li>
                <li><p>Proses klaim garansi wajib dibawa terlebih dahulu ke showroom Oto.cmd terdekat.</p></li>
                <li><p>Jangka waktu proses perbaikan tidak dapat ditentukan tergantung pada kerusakan yang timbul.</p></li>
                <li><p>Garansi tidak berlaku terhadap kerusakan akibat bencana alam atau kecelakaan.</p></li>
                <li><p>Garansi tidak berlaku terhadap kendaraan yang dimodifikasi dan tidak sesuai ketentuan pabrikan mobil. (contoh knalpot tidak standard, Bore-up engine, ketinggian suspensi kendaraan)</p></li>
                <li><p>Garansi tidak berlaku terhadap kerusakan akibat kesengajaan atau kelalaian penggunaan. (contoh tidak merawat kendaraan secara intensif atau kesalahan dalam pengisian/penggunaan jenis bahan bakar, Over Running, menerobos banjir, dsb.)</p></li>
                <li><p>Claim garansi hanya dapat dilakukan oleh debitur yang tercatat pada perjanjian. (dapat dikuasakan)</p></li>
              </ul>
            </div>
          </div>
        </div>
      </Modal>
    </footer>
  )
}

export default Footer